export default {
  getSearchConfigs: {  //产品综合查询 -按钮数据
    url: '/ec-fast-propose-api/propose/getSearchConfigs',
    type: 'post'
  },
  getStore: {  //店铺下拉
    url: '/ec-fast-propose-api/propose/getStore',
    type: 'post'
  },
  saleNumTopTen: {  //产品综合查询 -按钮数据
    url: '/ec-fast-propose-api/propose/product/saleNum/topTen',
    type: 'post'
  },
  storeRecords: {  //产品综合查询 -记录搜索店铺
    url: '/ec-fast-propose-api/propose/saveOrUpdate/store/records',
    type: 'post'
  },
  baseData: {  //产品综合查询 -产品基础属性查看（产品编码）
    url: '/ec-fast-propose-api/propose/product/code/baseData',
    type: 'post'
  },
  getMainModel: {  //产品综合查询 -产品基础属性查看（产品编码）
    url: '/ec-fast-propose-api/propose/getMainModel',
    type: 'post'
  },
  getClassificationRatio: {  //型号推荐查询 -产品基础属性查看（产品编码）
    url: '/ec-fast-propose-api/propose/getClassificationRatio',
    type: 'post'
  },
  queryCategory: {  //型号推荐查询 -类别下拉
    url: '/ec-fast-propose-api/propose/queryCategory',
    type: 'get'
  },
  getClassificationRatio: {  //型号推荐查询 -搭配分类占比
    url: '/ec-fast-propose-api/propose/getClassificationRatio',
    type: 'post'
  },
  getCategoryMappingBigModel: {  //型号推荐查询 -搭配分类占比
    url: '/ec-fast-propose-api/propose/getCategoryMappingBigModel',
    type: 'post'
  },
  getBigModelSalesTop: {  //型号推荐查询 -搭配类别销量Top10
    url: '/ec-fast-propose-api/propose/getBigModelSalesTop',
    type: 'post'
  },
  categoryTopTen: {  //型号推荐查询 -分类销量top10排名
    url: '/ec-fast-propose-api/propose/product/category/topTen',
    type: 'post'
  },
  getPriceScreening: {  //型号推荐查询 -分类销量top10排名
    url: '/ec-fast-propose-api/propose/getPriceScreening',
    type: 'post'
  },
  getProductBasisInfo: {  //型号推荐查询 -搭配类别销量Top10产品基础信息
    url: '/ec-fast-propose-api/propose/getProductBasisInfo',
    type: 'post'
  },
  productComparison: {  //产品对比-型号查询
    url: '/ec-fast-propose-api/propose/productComparison',
    type: 'post'
  },
  optionsn: {  //下拉选项
    url: '/ec-fast-propose-api/propose/product/options',
    type: 'post'
  },
  bigModelBaseData: {  //产品组合查询-产品基础信息查看（大型号）
    url: '/ec-fast-propose-api/propose/product/bigModel/baseData',
    type: 'post'
  },
  getDataRange: {  //获取数据范围
    url: '/ec-fast-propose-api/propose/getDataRange',
    type: 'get'
  },
  updateDataRange: {  //更改数据范围
    url: '/ec-fast-propose-api/propose/updateDataRange',
    type: 'get'
  },
  getMainModels: {  //更改数据范围
    url: '/ec-fast-propose-api/propose/getMainModels',
    type: 'get'
  },
  minAmountListPage: {  //最低成交金额查看权限配置列表
    url: '/ec-fast-propose-api/permission/config/minAmount/listPage',
    type: 'post'
  },
  mainPushModelListPage: {  //主推型号权限配置列表
    url: '/ec-fast-propose-api/permission/config/mainPushModel/listPage',
    type: 'post'
  },
  addAmountModel: {  //主推型号权限配置列表
    url: '/ec-fast-propose-api/permission/config/add/amount/Model',
    type: 'post'
  },
  userMsgList: {  //用户信息列表
    url: '/ec-fast-propose-api/permission/config/config/userMsgList',
    type: 'get'
  },
  deleteAmountModel: {  //用户信息列表
    url: '/ec-fast-propose-api/permission/config/delete/amount/Model',
    type: 'get'
  },
  getMainModelStore: {  //获取主推型号界面店铺下拉
    url: '/ec-fast-propose-api/propose/getMainModelStore',
    type: 'get'
  },
  getMainModelPageList: {  //获取主推型号导入查询分页
    url: '/ec-fast-propose-api/propose/getMainModelPageList',
    type: 'post'
  },
  modifyMainModelConfig: {  //修改主推型号配置
    url: '/ec-fast-propose-api/propose/modifyMainModelConfig',
    type: 'post'
  },
  addMainModelConfig: {  //修改主推型号配置
    url: '/ec-fast-propose-api/propose/addMainModelConfig',
    type: 'post'
  },
  deleteMainModelConfig: {  //修改主推型号配置
    url: '/ec-fast-propose-api/propose/deleteMainModelConfig',
    type: 'delete'
  },
  threeDimensionalImg: {  //查询产品三维图分页信息
    url: '/ec-fast-propose-api/propose/product/threeDimensionalImg',
    type: 'post'
  },
  
}